<template>
    <span>
        <b-button
            class="align-baseline"
            title="Locks"
            variant="default"
            @click="handleLocksClick"
        >
            <font-awesome-icon :icon="['fas', 'lock']"></font-awesome-icon>
        </b-button>
    </span>    
</template>

<script>
    import { mapGetters } from 'vuex';
    import FormSelect from '../../../generic/form-select/form-select.vue';

    export default {
        methods: {
            handleLocksClick() {
                this.params.click && this.params.click(this.params.data);
            },
        },
    }
</script>